import { render, staticRenderFns } from "./TableGridColumn.vue?vue&type=template&id=9a960412"
import script from "./TableGridColumn.vue?vue&type=script&lang=js"
export * from "./TableGridColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports